<!-- 销售出库单出仓专用 -->
<template>
    <div class="business-content-main sales-order-edit-v2" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <!--   form     -->
            <div class="section-title">
                <div>
                    <span>订单信息{{submitData.OrderCode?'【'+submitData.OrderCode+'】':''}}</span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="outWarehouse()"
                        v-if="permission.saleOut && !submitData.IsDelivery"
                        >整单出仓</el-button
                    >
                </div>
            </div>
            <div class="order-infoes">
                <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择客户" prop="EntpCusName">
                                    <el-input size="small" disabled v-model.trim="submitData.EntpCusName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="业务员" prop="SId">
                                    <el-input size="small" disabled v-model.trim="submitData.SName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="联系电话" prop="PhoneNum">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.PhoneNum"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式" prop="ShipTypeName">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.ShipTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input
                                        size="small"
                                        min="0"
                                        type="number"
                                        step="0.01"
                                        :disabled="dataReadonly"
                                        v-model.trim="submitData.ShipAmount"
                                        @change="resetHeight"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayTypeName">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.PayTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseName">
                                    <el-input
                                        :title="submitData.WarehouseName"
                                        v-model="submitData.WarehouseName"
                                        style="width: 100%"
                                        size="small"
                                        :disabled="true"
                                    ></el-input>                                     
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5" v-if="funcConfig">
                            <div class="grid-content bg-purple">
                                <el-form-item label="跟单采购员" prop="FollowerId">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.FollowerName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流公司" prop>
                                    <el-input
                                        size="small"
                                        v-if="dataReadonly"
                                        :title="submitData.LogisticName"
                                        v-model="submitData.LogisticName"
                                        style="width: 100%"
                                        :disabled="true"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流单号" prop="LogisticsOrderNo">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.LogisticsOrderNo" :max="30"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col v-if="isOrgShow" :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="部门" prop="OrgId">
                                    <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.OrgName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="isUseSource?5:7">
                            <div class="grid-content bg-purple">
                                <el-form-item label="收货地址" prop="FullAddress">
                                    <el-autocomplete
                                        size="small"
                                        :disabled="dataReadonly"
                                        v-model.trim="submitData.FullAddress"
                                        style="width: 100%"
                                    ></el-autocomplete>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="isUseSource?10:12">
                            <div class="customer-view">
                                <el-form-item label="客人要求" class="grid-content bg-purple">
                                    <el-input size="small" :disabled="dataReadonly" v-model="submitData.Remark"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    <el-col :span="4" v-if="isUseSource">
                        <div class="grid-content bg-purple">
                            <el-form-item label="订单来源">
                                <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.CusSourcesName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>    
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title">
                <div>
                    商品明细
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" class="infinite-list-special-class">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
                row-id="rowkey"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i :class="['el-icon-caret-top', { active: sortActive === 'top' }]" title="升序,从小到大排序" @click="changeTableSort('top', 'APCode')"></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]">
                            <span class="sp-i">
                                <i v-if="row.MainImage" title="有图片的配件信息" class="el-icon-picture" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                                <i v-else title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]">
                            <span class="sp-i">
                                <i v-if="row.MainImage" title="有图片的配件信息" class="el-icon-picture" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                                <i v-else title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件编码"
                            v-model="scope.row.APCode"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodNameItem" title="配件名称" show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]">{{ row.GoodName }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件名称"
                            v-model="scope.row.GoodName"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="160" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            :disabled="dataReadonly"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="数量" width="100" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            {{ row.Unit }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="ReferencePrice" title="参考售价" width="140" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">当配件商品有过报价历史时，显示配件商品的最新报价价格； <br />若配件商品从未报价给客户时，则显示配件商品的零售价格</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            {{ row.ReferencePrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="MarketPrice" title="销售价" width="120" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格； <br />若配件商品从未销售过，则不显示数值</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op item-row">
                            {{ row.MarketPrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="BillingPrice" title="开单价" width="120" v-if="isBPriceShow" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.BillingPrice }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="xszj" title="销售总价" width="80" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ ((row.MarketPrice ? row.MarketPrice : 0) * (row.Count ? row.Count : 0)).toFixed(2) }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="ly" title="留余" width="80" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                若未选定出仓仓库，显示的留余数为总库存的商品留余数； <br />若已选中出仓仓库，显示的留余数为该仓库下的商品留余数；
                                <br />注意：这里不统计退货的商品数量
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip
                                effect="dark"
                                :tabindex="-1"
                                :content="
                                    '待入仓(' +
                                    row.POrderWaitInQuantity +
                                    '）  待出仓(' +
                                    row.OrderWaitOutQuantity +
                                    '）  库存(' +
                                    row.StorageInventory +
                                    '）' +
                                    (isIntentShow ? '  在订数(' + (row.IntenCount ? row.IntenCount : 0) + '）' : '')
                                "
                                placement="top"
                            >
                                <div
                                    :class="{
                                        'color-red': row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity <= 0
                                    }"
                                >
                                    {{ row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                                </div>
                            </el-tooltip>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cc" title="出仓" width="90" resizable>
                    <template v-slot="{ row }">
                        <el-button
                            @click="outWarehouse(row)"
                            size="mini"
                            class="search-btn btn-primary"
                            style="margin-top: 1px"
                            v-if="permission.saleOut && !row.IsDelivery && !isForbidBatch"
                            >出仓</el-button
                        >
                        <div v-if="isForbidBatch" class="div-padding-12">
                            {{ row.IsDelivery ? '已出仓' : row.WarehousedCount > 0 ? '部分出仓' : '未出仓' }}
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="bottom-div">
                <div class="ship-amount" v-if="noFee">
                    运费：
                    <span class="discount-count">￥ {{ submitData.ShipAmount * 1 }}</span>
                </div>
                <div :class="['subzone', { 'no-fee': !noFee }]">
                    <div class="part">
                        <div class="dismoney">
                            <div class="distitle">
                                <el-select v-model="submitData.DiscountType" :disabled="dataReadonly || (type == 8 && hasPaid)" placeholder="请选择">
                                    <el-option v-for="item in discountOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <el-input-number
                                v-if="submitData.DiscountType === 1"
                                size="small"
                                :disabled="dataReadonly || (type == 8 && hasPaid)"
                                v-model="submitData.DiscountAmount"
                                :min="0"
                                :step="0.01"
                                :precision="2"
                                controls-position="right"
                                :max="Number(allMoney.toFixed(2))"
                                style="width: 134px"
                            ></el-input-number>
                            <div class="percent-view" v-else-if="submitData.DiscountType === 2">
                                <el-input-number
                                    placeholder="请输入"
                                    :controls="false"
                                    :min="0"
                                    :max="100"
                                    :precision="2"
                                    :disabled="dataReadonly || (type == 8 && hasPaid)"
                                    v-model="submitData.DiscountRate"
                                ></el-input-number>
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                    <div class="part">
                        <div>
                            <span style="margin: 0 12px" v-if="!noFee">=</span>
                            实收金额：
                            <span class="discount-count">￥ {{ discountCount }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   出仓     -->
        <el-dialog :close-on-click-modal="false" title="出仓" :visible.sync="outVisible" width="1000px">
            <div v-if="outVisible">
                <warehouseOut
                    :tcckType="tcckType"
                    :APList="warehouseGoodsList"
                    :SaleOutOrderOut="true"
                    :OrderWarehouse="warehouseList[0]"
                    :ZoneId="submitData.ZoneId"
                    :EntpCusOId="id"
                    @closeDialog="closeOutDialog"
                ></warehouseOut>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import breadcrumb from '@/components/common/breadcrumb';
import warehouseOut from '@/components/business/salesManage/warehouseOut_New';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        warehouseOut,
        breadcrumb,
        APMsg
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        }
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            addressList: [],
            needConfirm: true,
            EntpTempGoodsIdEdit: '',
            loading: false,
            dataReadonly: true,
            APMsgVisible:false,
            searchVisible: false,
            outVisible: false,
            isIntentShow: false,
            allNum: 1,
            allMoney: 0,
            submitData: {
                SId: userMsg.EmployeeId,
                WarehouseId: '',
                WarehouseName: '',
                FollowerId: '',
                SubmissionState: false,
                EntpCusOId: '',
                UserId: userMsg.EmployeeId,
                ShipAmount: '',
                DiscountAmount: '',
                PayTypeName: '',
                ShipTypeName: '',
                FullAddress: '',
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                LogisticId: '',
                LogisticName: '',
                LogisticItem: '',
                LogisticsOrderNo: '',
                DiscountType: 0,
                DiscountRate: 0,
                OrgId: '',
                OrgName: '',
                CusSources:'',
                CusSourcesName: '',                
            },
            Limit: 10,
            dataList: [],
            warehouseList: [], //入库商品列表
            warehouseGoodsList: [], //入库商品列表
            id: '',
            pageTitle: '',
            rules: {
                ShipTypeName: [
                    {
                        required: true,
                        message: '请选择发货方式',
                        trigger: 'blur'
                    }
                ],
                EntpCusName: [
                    {
                        required: true,
                        message: '请选择客户',
                        trigger: 'blur'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '请选择业务员',
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '填写电话号码',
                        trigger: 'blur'
                    }
                ],
                FullAddress: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'change'
                    }
                ],
                PayTypeName: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                WarehouseName: [{ required: true, message: '请选择仓库', trigger: 'blur' }],
                OrgId: [{ required: true, message: '请选择部门', trigger: 'blur' }],
                CusSources: [
                    {
                        required: true,
                        message: '请选择来源',
                        trigger: 'change'
                    }
                ]                   
            },
            permission: {},
            funcConfig: false,
            discountOptions: [
                { id: 0, value: '无优惠' },
                { id: 1, value: '优惠金额' },
                { id: 2, value: '整单优惠' }
            ],
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            // 汽配编码排序标识
            sortActive: '',
            //留余是否计算待入数据
            //否：留余数=库存数-待出库数
            //是：留余数=库存数-待出库数+待入库数
            isAddWaitIn: true,
            // 整单出仓，弹框模式，1 同仓出库，0 单个出仓
            tcckType: 0,
            isBPriceShow: false, //开单价
            isOrgShow: false, //开单部门
            isOriginShow: false, //显示产地
            isForbidBatch: false,
            isUseSource: false,//是否启用销售开单显示来源
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        // document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        let that = this;
        that.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        // 监听滚动事件
        window.onresize = () => {
            that.resetHeight();
        };
    },
    computed: {
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;

            if (this.submitData.DiscountType === 2) {
                // 处理整单优惠
                discountCount = (this.submitData.DiscountRate / 100) * this.allMoney;
            }
            if (!discountCount || this.submitData.DiscountType === 0) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            return (this.allMoney * 1 - discountCount + shipAmount > 0 ? this.allMoney * 1 - discountCount + shipAmount : 0).toFixed(2);
        },
        // 列表高度，当type为6时高度自适应
        infiniteTableHeight() {
            return 'auto';
        },
        // 收款金额是否大于零，当为true时，不能修改优惠金额
        hasPaid() {
            return this.submitData.Paid && this.submitData.Paid * 1 > 0;
        },
    },
    methods: {
        // handleKeyEvent(e) {
        //     let key = window.event.keyCode;
        //     if (key === 107 || key === 187) {
        //         if (!this.searchVisible) this.addItem(false);
        //     }
        //     if (key == 113) {
        //         this.searchVisible = true;
        //     }
        // },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'xsgdy',
                    'lybsdr',
                    'syztsj',
                    'xskdxskdj',
                    'xskdxskdbm',
                    'kdspcd',
                    'xzxsjkqbcc',
                    'xsddly'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'xsgdy':
                                    this.funcConfig = result;
                                    break;
                                case 'lybsdr':
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'syztsj':
                                    this.isIntentShow = result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'kdspcd': //产地
                                    this.isOriginShow = result;
                                    break;
                                case 'khgzzq': //开启挂账限制
                                    this.isCheckCredit = result;
                                    break;
                                case 'xzxsjkqbcc': //限制分批出仓
                                    this.isForbidBatch = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;                                  
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        async init() {
            this.permission = this.$util.getPermission('SalesOutWhOrdersTakeOut');

            this.id = this.$route.query.id;
            this.submitData.EntpCusOId = this.$route.query.id;

            this.needConfirm = false;
            this.pageTitle = '货物出仓';
            this.getConfigByCodes().then(() => {
                this.getOrderDetail();
            });

            setTimeout(() => {
                this.resetHeight();
            }, 0);
        },
        // 出仓
        outWarehouse(item) {
            this.warehouseGoodsList = [];
            this.tType = 1;
            if (item) {
                this.warehouseGoodsList.push({ ...item }); // 单个入仓
                this.tcckType = 0;
            } else {
                this.warehouseGoodsList = [...this.dataList]; // 整单入仓
                this.tcckType = 1;
            }
            this.outVisible = true;
        },
        closeOutDialog(edit, IsAllOutWarehouse) {
            this.outVisible = false;
            this.needConfirm = false;
            if (IsAllOutWarehouse) {
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
                return;
            }
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpCusSaleOutOrder',
                    data: {
                        EntpOutSOId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.SubmissionState = Boolean(data.SubmissionState);
                    data.UserId = this.userMsg.EmployeeId;
                    data.LogisticItem = data.LogisticName;

                    this.submitData = data;
                    if (!this.submitData.SId) this.submitData.SId = this.userMsg.EmployeeId;

                    this.warehouseList.push({
                            WarehouseId: data.WarehouseId,
                            WarehouseName: data.WarehouseName,
                        });
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        this.$set(DetailList[i], 'MarketPrice', DetailList[i].Price);
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                    }

                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 设置展示合计数据行
        setSummaries(param) {
            const { data } = param;
            let num = 0;
            let price = 0;
            data.forEach(ele => {
                num += Number(ele.Count);
                price += Number(ele.Count * ele.MarketPrice ? (ele.Count * ele.MarketPrice).toFixed(3) : 0);
            });
            var countColIndex=0;
            var sumColIndex=0;
            countColIndex=param.columns.findIndex(item=>{ return item.title == '数量'});
            sumColIndex=param.columns.findIndex(item=>{ return item.title == '销售总价'});

            var arr=new Array(param.columns.length);
            if(countColIndex!=-1){
                arr[countColIndex]=num;
                 arr[countColIndex-1]="总数量";
            }
            if(sumColIndex!=-1){
                arr[sumColIndex]= price.toFixed(2);
                arr[sumColIndex-1]="销售商品总额";
            }
            return [arr]; 
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },      
    }
};
</script>
<style lang="less" scoped>
.s-btn,
.s-btn:focus,
.s-btn.is-active,
.s-btn.is-disabled:active,
.s-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #ea7060;
    background-color: #ea7060;
    margin-right: 2px;
}

.s-btn.is-disabled:hover,
.s-btn:hover,
.s-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.b-btn,
.b-btn:focus,
.b-btn.is-active,
.b-btn.is-disabled:active,
.b-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #bac225;
    background-color: #bac225;
    margin-right: 2px;
}

.b-btn.is-disabled:hover,
.b-btn:hover,
.b-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.el-form-item {
    margin-bottom: 0px;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 40%;
    float: left;
}
.form-uploadImg {
    margin-bottom: 20px;
}
.form-uploadImg div {
    width: 100%;
    font-size: 14px;
    margin-bottom: 10px;
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.item-row{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.info-icon {
    vertical-align: top;
    margin-top: 2px;
    margin-right: 5px;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
.el-icon-picture {
    color: rgb(240, 155, 27);
    font-size: 18px;
    vertical-align: top;
    margin-top: 3px;
    cursor: pointer;
    margin-right: 3px;
}
</style>
<style lang="less">
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;
    .popper__arrow {
        color: #303133;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.sales-order-edit-v2 {
    #search-dialog {
        margin-right: 35px;
    }
    .el-row {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 10px;
        }
    }
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 8px 0;
                }
                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }
    .bottom-div {
        margin-top: 24px;
        .ship-amount {
            text-align: right;
            margin-bottom: 16px;
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
        .part {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 16px;
        }
        .no-fee {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
        .subzone {
            .dismoney {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                height: 32px;
                .percent-view {
                    display: flex;
                    align-items: center;
                    span {
                        margin-left: 12px;
                    }
                }
                .el-input-number {
                    width: 110px;
                    .el-input__inner {
                        height: 32px;
                    }
                }
                .el-select {
                    margin-right: 12px;
                    .el-input__inner {
                        width: 110px;
                        height: 32px;
                        color: red;
                    }
                    .el-input__suffix {
                        top: 4px;
                    }
                    .is-focus {
                        .el-input__suffix {
                            top: -4px;
                        }
                    }
                }
            }
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .salecounts-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
            margin-right: 3px;
        }
    }
}
.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}
</style>
